mtl.alloy.factory['layout-header'] = (function($, app, util) {
	'use strict';

	/**
	 * Controller for the layout header element.
	 */
	return function(element, options) {

		var $element = $(element);

		// ---------------------------------------------------------


		/**
		 * Hide the off-canvas menu.
		 */
		function hideOffCanvasMenu() {

			$(document.body).removeClass('ui-show-ocm');

		}


		/**
		 * Toggle off-canvas menu visibility.
		 */
		function toggleOffCanvasMenu() {

			$(document.body).toggleClass('ui-show-ocm');

		}


		// Hide the off-canvas menu when leaving phone breakpoints
		app.breakpoint.when('phone-l phone-s', null, hideOffCanvasMenu);


		// Priority-menu variables
		var $tabletMenu;
		var tabletMenuItemSlice = -1;
		var isTabletMenuVisible = false;


		/**
		 * Show the tablet overflow menu.
		 */
		function showTabletMenu() {

			if (tabletMenuItemSlice < 0 || isTabletMenuVisible || app.breakpoint.not('tablet-l tablet-s')) {
				return;
			}

			if ($tabletMenu == null) {
				var $container = $element.find('.id-menu-container');
				$tabletMenu = $container
					.find('ul')
					.first()
					.clone()
					.addClass('tablet-menu')
					.addClass('is-collapsed')
					.insertAfter($container)
				;
			}

			var $items = $tabletMenu.children();
			$items.slice(0, tabletMenuItemSlice).hide();
			$items.slice(tabletMenuItemSlice).show();

			$tabletMenu
				.stop(true, true)
				.queueAddClass('is-visible')
				.delay(25)
				.queueRemoveClass('is-collapsed')
			;

			$element.addClass('ui-show-tablet-menu');

			isTabletMenuVisible = true;

		}


		/**
		 * Hide the tablet overflow menu.
		 */
		function hideTabletMenu() {

			if ($tabletMenu == null || !isTabletMenuVisible) {
				return;
			}

			$tabletMenu
				.stop(true, true)
				.queueAddClass('is-collapsed')
				.delay(400)
				.queueRemoveClass('is-visible')
			;

			$element.removeClass('ui-show-tablet-menu');

			isTabletMenuVisible = false;

		}


		/**
		 * Toggle the visibility of the tablet overflow menu.
		 */
		function toggleTabletMenu() {

			if (isTabletMenuVisible) {
				hideTabletMenu();
			}
			else {
				showTabletMenu();
			}

		}


		/**
		 * Update the content of the tablet overflow menu.
		 */
		function updateTabletMenu() {

			if (app.breakpoint.not('tablet-l tablet-s')) {
				return;
			}

			var $items = $element.find('.id-menu-container li');

			var firstTop = $items[0].offsetTop;

			for (var i = 1, ix = $items.length; i < ix; i++) {
				if ($items[i].offsetTop > firstTop) {
					break;
				}
			}

			tabletMenuItemSlice = (i < ix) ? i : -1;

			$element.find('.id-menu-btn').toggleClass('has-tablet-menu', i < ix);

		}


		// Listen for click events on the menu button
		$element.on('click', '.id-menu-btn', function() {

			if (app.breakpoint.is('phone-l phone-s')) {
				toggleOffCanvasMenu();
			}

			else if (app.breakpoint.is('tablet-l tablet-s')) {
				toggleTabletMenu();
			}

		});

		$(window).on('resize orientationchange', responiveDomChanges);
		responiveDomChanges();

        function responiveDomChanges(){
        	if (app.breakpoint.is('phone-l phone-s')) {
	            $('.ks-tabset').after($('.ks-tabset__container'));
	        } else {
	            $('.ks-tabset__menu').after($('.ks-tabset__container'));
	        }
        }


		// Update the tablet overflow menu on resize and document.ready
		$(window).on('resize orientationchange', util.debounce(updateTabletMenu, 200));
		$(document).ready(updateTabletMenu);

		// Hide the tablet overflow menu when leaving tablet breakpoints
		app.breakpoint.when('tablet-l tablet-s', null, hideTabletMenu);


		// ---------------------------------------------------------


		// Scroll-top variables
		var scrollPositionWas = 0;


		/**
		 * Update the scroll-top status.
		 */
		function updateScrollTop() {

			var scrollPosition = $(window).scrollTop() | 0;

			var diff = (scrollPosition - scrollPositionWas) | 0;
			if (Math.abs(diff) >= 2) {

				var threshold = (diff > 0) ?
					30 :  // scrolling down
					200; // scrolling up

				$(document.body).toggleClass('ui-scroll-top', scrollPosition < threshold);

			}

			scrollPositionWas = scrollPosition;

		}


		// Listen for scroll events for updating the scroll-top status
		$(window).on('scroll', util.throttle(updateScrollTop, 67));

		// Update the scroll-top on document.ready
		$(document).ready(updateScrollTop);


		// ---------------------------------------------------------


		/**
		 * Close the login form.
		 */
		function closeLoginForm() {

			$element.removeClass('ui-show-login');

		}


		/**
		 * Toggle the visibility of the login form.
		 */
		function toggleLoginForm() {

			$element.toggleClass('ui-show-login');

		}


		// Open the login form when the login button is clicked
		$element.on('click', '.id-login-btn', function(event) {
			if (app.breakpoint.not('phone-l phone-s')) {
				event.preventDefault();
				closeDeliveryInfo();
				toggleLoginForm();
			}
		});

		// Close the login form when clicking close
		$element.on('click', '.id-close-login-btn', closeLoginForm);

		// Close the login form when leaving tablet breakpoints
		app.breakpoint.when('tablet-l tablet-s', null, closeLoginForm);

		// ---------------------------------------------------------


		/**
		 * Close the delivery info.
		 */
		function closeDeliveryInfo() {

			$element.removeClass('ui-show-delivery');

		}


		/**
		 * Toggle the visibility of the delivery info.
		 */
		function toggleDeliveryInfo() {

			$element.toggleClass('ui-show-delivery');

		}


		// Open the delivery info when the delivery button is clicked
		$element.on('click', '.id-delivery-btn', function(event) {
			if (app.breakpoint.not('phone-l phone-s')) {
				event.preventDefault();
				closeLoginForm();
				toggleDeliveryInfo();
			}
		});

		// Close the delivery info when clicking close
		$element.on('click', '.id-close-delivery-btn', closeDeliveryInfo);

		// Close the delivery info when leaving tablet breakpoints
		app.breakpoint.when('tablet-l tablet-s', null, closeDeliveryInfo);


		// ---------------------------------------------------------


		/**
		 * Hide the secondary nav
		 */
		function hideSecondaryNav() {

			$('.layout-header-nav__menu-secondary-container').hide();

		}


		/**
		 * Show the secondary nav
		 */
		function showSecondaryNav() {

			$('.layout-header-nav__menu-secondary-container').show();

		}


		// Show the secondary nav menu 
		$element.on('mouseenter', '.layout-header-nav__menu li:eq(1)', function(event) {
			if (app.breakpoint.is('desktop')) {
				showSecondaryNav();
			}
		});

		// Hide the secondary nav menu 
		$element.on('mouseleave', '.layout-header-nav__menu-secondary-container, .layout-header-nav__menu-container', function(event) {
			event.stopPropagation();
			hideSecondaryNav();
		});

		// Hide the secondary nav menu 
		$element.on('mouseenter', '.layout-header-nav__menu li:not(:eq(1))', function(event) {
			event.stopPropagation();
			hideSecondaryNav();
		});

	};

}($, app, util));
